import { useEffect } from 'react'
import { Handler } from 'shared/helpers/typeHelper'

interface ExecuteOnMountProps {
  onMount: Handler
}

export function ExecuteOnMount({ onMount }: ExecuteOnMountProps) {
  useEffect(() => {
    onMount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
